import { Outlet } from 'react-router-dom';
import { Grid2 as Grid } from '@mui/material';
import AuthFooter from '../../component/cards/AuthFooter';
import logo from 'assets/images/logos/ConnectedHeart_RGB_Logo Preto.svg';
import AuthCardWrapper from 'views/pages/authentication/AuthCardWrapper';
import AuthWrapper1 from 'views/pages/authentication/AuthWrapper1';

// assets

// ================================|| AUTH3 - LOGIN ||================================ //

function MinimalLayout() {
    return (
        <AuthWrapper1>
            <Grid
                container
                direction="column"
                justifyContent="flex-end"
                sx={{ minHeight: '100vh' }}
            >
                <Grid size={12}>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{ minHeight: 'calc(100vh - 68px)' }}
                    >
                        <Grid sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Grid sx={{ mb: 3 }}>
                                        <img
                                            src={logo}
                                            alt="Connected Heart"
                                            width="100%"
                                            height="100%"
                                        />
                                    </Grid>
                                    <Grid size={12}>
                                        <Outlet />
                                    </Grid>
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12} sx={{ px: 2, py: 1 }}>
                    <AuthFooter />
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
}

export default MinimalLayout;
